export const IO_WRITE= 'IO_WRITE'
export const OPERATIONS_WRITE= 'OPERATIONS_WRITE';
export const FAULTS_WRITE = 'FAULTS_WRITE';
export const RETUNE_LOAD = 'RETUNE_LOAD';
export const RETUNE_SAVE = 'RETUNE_SAVE';
export const SETDATE = 'SETDATE';
export const FUEL_PROP_WRITE = 'FUEL_PROP_WRITE';
export const SEQUENCE_OVERRIDES = 'SEQUENCE_OVERRIDES';
export const GRAPHICS_WRITE = 'GRAPHICS_WRITE';



// A- Admin, B - Test/Field Eng, C - Test/Field Tech, D - Operators, E - Other DFCA/DFCC, F - Customer(No Access at all)
const RULES = {
    B: ['B','C','D',IO_WRITE,OPERATIONS_WRITE, FAULTS_WRITE, RETUNE_SAVE, RETUNE_LOAD, SETDATE, FUEL_PROP_WRITE, SEQUENCE_OVERRIDES, GRAPHICS_WRITE ],
    C: ['C','D',IO_WRITE, OPERATIONS_WRITE, FAULTS_WRITE, RETUNE_SAVE, RETUNE_LOAD, SETDATE, FUEL_PROP_WRITE, SEQUENCE_OVERRIDES, GRAPHICS_WRITE],
    D: ['D', IO_WRITE, OPERATIONS_WRITE, RETUNE_SAVE, SEQUENCE_OVERRIDES, GRAPHICS_WRITE],
    E: ['E'],
    F: ['F']
};



export const isAuthorized = (role,rule) => role === 'A' || (RULES[role] && RULES[role].includes(rule));
